import { Breadcrumbs, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';
import { useApplication } from '../../../../context/ApplicationContext';

// import schemas
import VerwendungsNachweisSchema from '../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
import { enumT } from '../../../../utils/helper';
const VN_P = VerwendungsNachweisSchema.attributes;

const BreadCrumbVerwendungsnachweis: FC<{}> = () => {
	const { application } = useApplication();

	return (
		<>
			<Breadcrumbs separator='›' aria-label='breadcrumb' sx={{ maxWidth: '81.875rem' }}>
				<Typography color='secondary'>Mein Bereich</Typography>
				<Typography color='secondary'>Mein Antrag</Typography>
				<Typography color='secondary'>{enumT(get(application, VN_P.Allgemein_Nachweistyp.path, ''))}</Typography>
				<Typography color='primary'>
					{get(application, VN_P.Antrag.schema.attributes.MKS.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path, '*')}
				</Typography>
			</Breadcrumbs>
		</>
	);
};

export default BreadCrumbVerwendungsnachweis;
